import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subject, Subscription} from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {News} from '../../../shared/interfaces/news';
import {NewsService} from '../../../shared/services/news.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SEOService} from '../../../shared/services/seo.service';
import { CmsService } from 'src/app/modules/cms/services/cms.service';
import {StoreLocatorPageService} from '../../store-locator-page/store-locator-page.service';

@Component({
  selector: 'app-news-detail',
  templateUrl: './news-detail.component.html',
  styleUrls: ['./news-detail.component.scss']
})
export class NewsDetailComponent implements OnInit, OnDestroy {

  public news$: Observable<News>;

  public cmsNews = null;
  public isLoaded: boolean = false;
  public isNetworkSite: boolean = false;
  public hasMultipleStores: boolean = false;
  public hasCnd: boolean = false;
  private unsubscribe$ = new Subject;

  private getStoresSubscription: Subscription;

  constructor(
    private _newsService: NewsService,
    private _seoService: SEOService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _cmsService: CmsService,
    private _storeLocatorService: StoreLocatorPageService
  ) { }


  ngOnInit(): void {
    this.getStoresSubscription = this._storeLocatorService.getStores();
    this._route.paramMap.pipe(takeUntil(this.unsubscribe$)).subscribe(params => {
      this._cmsService.hasCmsEnabled$.pipe(takeUntil(this.unsubscribe$)).subscribe(isEnabled => {
        if (isEnabled != undefined && isEnabled == true) {
          this.getSingleNews(params, 3);
        } else if (isEnabled != undefined && isEnabled == false) {
          const newsId = params.get('id');
          this.news$ = this._newsService.getNewsItem(newsId);
          this.news$.pipe(takeUntil(this.unsubscribe$)).subscribe(x => {
            if (x) {
              this.setSeoData(x.title, x.image, x.text);
              this.isLoaded = true;
            }
          });
        }
      });
      this._cmsService.siteUrl$.pipe(takeUntil(this.unsubscribe$)).subscribe(siteUrl => {
        if (siteUrl && (siteUrl.includes('geotn.it') || siteUrl.includes('vacanzewelcometravel.it'))) {
          this.isNetworkSite = true;
        }
      });
      this._storeLocatorService.storesList$.pipe(takeUntil(this.unsubscribe$)).subscribe(storeList => {
        this.hasMultipleStores = storeList?.length > 1;
      });
    });
  }

  ngOnDestroy(): void {
    this.getStoresSubscription?.unsubscribe();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private getSingleNews(params, retry) {
    if (retry == 0) {
      this._router.navigate([""]);
    } else {
      const allpages = this._cmsService.getPages();
      if (allpages) {
        const news = allpages.find(x => x.path == params.get('id') && x.type.basePath == this._route.snapshot.data.cmsPath);
        this._cmsService.getPageById(news.id).pipe(takeUntil(this.unsubscribe$)).subscribe(newsArticle => {
          this.cmsNews = newsArticle;
          this.hasCnd = this.cmsNews.attributes.some((attr: string) => attr.includes("heyconad"));
          this.setSeoData(newsArticle.title, newsArticle.image, this._cmsService.stripHtml(newsArticle.shortDescription));
          this.isLoaded = true;
        })
      } else {
        setTimeout(() => {
          retry--;
          this.getSingleNews(params, retry);
        }, 250)
      }
    }
  }

  private setSeoData(title: string, image: string, description: string) {
    this._seoService.setTitle(title);
    this._seoService.setImage(image);
    this._seoService.setDescription(description);
  }
}
